<tui-root>
  <ngx-loading-bar [height]="'3px'" [includeSpinner]="false" [color]="'#0076ff'"/>
  <ngx-spinner
    bdColor="rgba(58,63,81,0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate-pulse"></ngx-spinner>
    <router-outlet/>
</tui-root>
